import { Alert as AntAlert, AlertProps } from "antd";
import styled from "styled-components";

export const Alert: typeof AntAlert = styled(AntAlert)<AlertProps>``;
